<script>
import Multiselect from "@vueform/multiselect";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    Multiselect
  },
  props: {
    visitasList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  data() {
    return {
      loadingData: false,
      clienteData: null,
      ultPedsData: null,
      dtListPesqCli: null,
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      }
    }
  },
  mounted() {
    // console.log('mounted visitas-table_0')
    // console.log(this.updating)
  },
  methods: {

    pesqCliente(evt){
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCli = res.data
        });
      }
    },

    escolheuCli(){
      console.log('escolheuCli')
      console.log(this.regSelecionado.cliente)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.regSelecionado.cliente }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
      })
    },

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'P':
          result = 'Programado'
          break
        case 'A':
          result = 'Atendido'
          break
        case 'X':
          result = 'Cancelado'
          break
      }
      return result
    },

    nomeTipo(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'V':
          result = 'Visita no Local'
          break
        case 'T':
          result = 'Ligação'
          break
        case 'W':
          result = 'Whatsapp'
          break
        case 'E':
          result = 'E-mail'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.visitasList.find((reg) => reg.id === dataID);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return
      } else {
        this.loadingData = true
        console.log('formSubmit_validado')

        this.errosValid = []
        api.post(`${getBaseUrl()}api/visita`, {
          visitaData: this.regSelecionado
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.loadingData = false
          this.showModal = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(res => {
            console.log(res)
            this.$emit('alterareg', this.regSelecionado)
          })
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
        })
      }
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.showModal = true;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Descrição</th>
        <th class="align-middle">Data</th>
        <th class="align-middle">Cliente</th>
        <th class="align-middle">Início</th>
        <th class="align-middle">Fim</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Tipo</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in visitasList" :key="data.id">
        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
              data.id
            }}</a>
        </td>
        <td>{{ data.descricao }} </td>
        <td>{{ formatDateTime(data.created_at) }} </td>
        <td>{{ data.cliente }} </td>
        <td>{{ data.inicio }} </td>
        <td>{{ data.fim }} </td>
        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : data.status === 'P' ? 'badge-soft-warning': 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td>
          <i class="fa fa-map-marker me-1" v-if="data.tipo === 'V'"></i>
          <i class="fa fa-phone me-1" v-if="data.tipo === 'T'"></i>
          <i class="fab fa-whatsapp me-1" v-if="data.tipo === 'W'"></i>
          <i class="fa fa-mail-bulk me-1" v-if="data.tipo === 'E'"></i>
          {{ nomeTipo(data.tipo) }}
        </td>

        <td>
          <div class="button-items">
            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>
            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>

    <b-modal :title="regSelecionado.id != null ? `Editar Vista (${ regSelecionado.id })` : 'Criar Nova Visita'" v-model="showModal" hide-footer>

      <div class="row" v-if="loadingData">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <form v-if="!loadingData" @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-12">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.descricao.required.$message">
                  {{ v$.regSelecionado.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="mb-3">
              <span >Cliente</span>

              <multiselect @search-change="pesqCliente"
                           @select="escolheuCli"
                           v-model="regSelecionado.cliente"
                           placeholder="Pesquisar cliente"
                           :options="dtListPesqCli"
                           :searchable="true"
                           label="nome"
                           track-by="nome"
                           value-prop="codigo">
                <template #option="slotProps">
                  <div class="row">
                    <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                      <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                    </div>
                    <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                    <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                  </div>
                </template>
              </multiselect>

            </div>
          </div>


          <div class="col-6">
            <div class="mb-3">
              <label for="inicio">Início</label>
              <input
                  id="inicio"
                  v-model="regSelecionado.inicio"
                  type="time"
                  class="form-control"
                  placeholder="Início"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="fim">Fim</label>
              <input
                  id="fim"
                  v-model="regSelecionado.fim"
                  type="time"
                  class="form-control"
                  placeholder="Fim"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="selectTipo">Tipo</label>
              <b-form-select
                  id="selectTipo"
                  v-model="regSelecionado.tipo"
                  class="mb-3 form-select form-control">
                <b-form-select-option value="V">
                  Visita no Local
                </b-form-select-option>
                <b-form-select-option value="T">
                  Ligação
                </b-form-select-option>
                <b-form-select-option value="W">
                  Whatsapp
                </b-form-select-option>
                <b-form-select-option value="E">
                  E-mail
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionado.status"
                  class="mb-3 form-select form-control"
                  :class="{'is-invalid': submitted && v$.regSelecionado.status.$error,}">
                <b-form-select-option value="P">
                  Programado
                </b-form-select-option>
                <b-form-select-option value="A">
                  Atendido
                </b-form-select-option>
                <b-form-select-option value="X">
                  Cancelado
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$.regSelecionado.status.$error" class="invalid-feedback">
                <span v-if="v$.regSelecionado.status.required.$message">
                  {{ v$.regSelecionado.status.required.$message }}
                </span>
              </div>
            </div>
          </div>



          <div class="col-6" v-if="regSelecionado.status === 'X'">
            <div class="mb-3">
              <label for="motivo">Motivo</label>
              <b-form-select
                  v-model="regSelecionado.motivo"
                  class="mb-3 form-select form-control">
                <b-form-select-option value="N">
                  Não encontrado
                </b-form-select-option>
                <b-form-select-option value="R">
                  Cliente Recusa Atendimento
                </b-form-select-option>
                <b-form-select-option value="F">
                  Fechado
                </b-form-select-option>
                <b-form-select-option value="N">
                  Negativa em Propostas
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>


        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>
  </div>

</template>
